import React, { useState, useEffect, useRef } from "react";
import { RCCButton, RCCGrid } from "react-common-components";
import Accordion from "src/components/Accordion";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { IIndicatorsLevel } from "src/pages/Indicators/Panel/components/interface";
import { IndicatorsGroupers } from "src/pages/Indicators/Panel/interface";
import ListOfChartsIndicator, { IRefListOfIndicatorsChart } from "../ListOfChartsIndicator";
import { IGrouperOfIndicators } from "./interface";

const FilterButtonSelected = "padding: 2px 8px; filter: brightness(0.5);";
const FilterButton = "padding: 2px 8px;";

const GrouperOfIndicatorsPresentationPanel: React.FC<IGrouperOfIndicators> = ({
	grouper,
	filters,
	groupersSelect,
	configs,
	configShowGoals,
	refModalValuesOfPeriodIndicators,
	printRef,
	recursiveProps
}) => {
	const { translate } = useTranslation();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	const listOfIndicatorsChartRef = useRef<IRefListOfIndicatorsChart>(null);

	const [filterList, setFilterList] = useState<IIndicatorsLevel | undefined>(recursiveProps?.initialFilterList);
	const [executeQuery, setExecuteQuery] = useState<boolean>(false);

	const filterIndicatorsOnClickCountBar = (situation: IIndicatorsLevel) => {
		let situationToUpdate: IIndicatorsLevel | undefined = situation;
		
		if(filterList && filterList === situation)
			situationToUpdate = undefined;
		
		setFilterList(situationToUpdate);
	};

	const handleClickGroupers = async (_e: any, expanded: boolean) => {
		if(!expanded)
			return;

		setExecuteQuery(true);
	};

	useEffect(() => {
		if(recursiveProps)
			setFilterList(recursiveProps.initialFilterList);
	}, [recursiveProps?.initialFilterList]);

	useEffect(() => {
		if(!executeQuery)
			return;
		listOfIndicatorsChartRef.current?.executeQuery();
		setExecuteQuery(false);
	}, [executeQuery]);

	return (
		<>
			<Accordion 
				header={
					<RCCGrid 
						container
						item 
						alignItems="center"
						justifyContent="space-between"
					>
						<span style={{ display: "flex", alignItems: "center"}}>
							{grouper.image !== null && (
								<Photo 
									hover
									name={grouper.imageName || ""}
									link={grouper.image !== "" ? `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${grouper.image}` : ""}
								/>
							)}
							{grouper.title !== null && translate(`indicatorWorkspace:${grouper.title}`)}
							{grouper.title2 !== null && translate(`indicatorWorkspace:${grouper.title2}`)}
							{grouper.title3 !== null && translate(`indicatorWorkspace:${grouper.title3}`)}
						</span>
						<RCCGrid container justifyContent="flex-end">
							{groupersSelect.group !== IndicatorsGroupers.INDICATOR_HIERARCHY && (
								<>
									{grouper.strategic > 0 && (
										<RCCButton 
											color="purple" 
											styleInline={filterList && filterList !== IIndicatorsLevel.STRATEGIC ? FilterButtonSelected : FilterButton}
											onClick={(e) => { e.stopPropagation(); filterIndicatorsOnClickCountBar(IIndicatorsLevel.STRATEGIC); }}
										>
											{grouper.strategic} {translate("estratégico(s)")}
										</RCCButton>
									)}
									{grouper.tactic > 0 && (
										<RCCButton 
											color="blue" 
											styleInline={filterList && filterList !== IIndicatorsLevel.TACTIC ? FilterButtonSelected : FilterButton}
											onClick={(e) => { e.stopPropagation(); filterIndicatorsOnClickCountBar(IIndicatorsLevel.TACTIC); }}
										>
											{grouper.tactic} {translate("tático(s)")}
										</RCCButton>
									)}
									{grouper.operational > 0 && (
										<RCCButton 
											color="orange" 
											styleInline={filterList && filterList !== IIndicatorsLevel.OPERATIONAL ? FilterButtonSelected : FilterButton}
											onClick={(e) => { e.stopPropagation(); filterIndicatorsOnClickCountBar(IIndicatorsLevel.OPERATIONAL); }}
										>
											{grouper.operational} {translate("operacional(s)")}
										</RCCButton>
									)}
								</>
							)}
							<Title color="purple" size="sm" styleInline="margin 0 4px;">{translate("Total")}: {grouper.count}</Title>
						</RCCGrid>
					</RCCGrid>
				}
				onChange={(e, expanded) => handleClickGroupers(e, expanded)}
			>		
				{grouper.groupersChildren && grouper.groupersChildren !== null && grouper.groupersChildren.length > 0 ? grouper.groupersChildren.map((grouperChildren) => (
					<GrouperOfIndicatorsPresentationPanel 
						key={`${grouperChildren.id}-${grouperChildren.id2}-${grouperChildren.id3}-grouperChildren-indicators-presentation-panel`}
						filters={filters}
						grouper={grouperChildren}
						groupersSelect={groupersSelect}
						configs={configs}
						configShowGoals={configShowGoals}
						refModalValuesOfPeriodIndicators={refModalValuesOfPeriodIndicators}
						printRef={printRef}
						recursiveProps={{
							initialFilterList: filterList
						}}
					/>
				)) : (
					<ListOfChartsIndicator 
					   ref={listOfIndicatorsChartRef}
					   printRef={printRef}
					   grouper={grouper}
					   filters={filters}
					   groupersSelect={groupersSelect}
					   filterList={filterList}
					   configs={configs}
					   configShowGoals={configShowGoals}
					   refModalValuesOfPeriodIndicators={refModalValuesOfPeriodIndicators}
				   />
				)}
			</Accordion>
		
		</>
	);
};

export default GrouperOfIndicatorsPresentationPanel;
